import React from 'react';
import styles from './index.module.less';
import { Affix, Col, Row, Skeleton } from 'antd';
import _ from 'lodash';
import { HomeArticleModel, HomeGPTsModel } from '@/types/home';
import BookItem from '../BookItem';
import HomeFullItem from '@/components/Home/HomeFullItem';
import GPTsItemList from '../GPTsItemList';
import { getPathTitle, imgUrl } from '@/shared/utils';
import useScreenSize from '@/lib/hooks/utils/useScreenSize';
import { useRouter } from 'next/router';
import SharePage from '@/components/Common/Share';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';

const ArticleDetailUI = ({
  model,
  gptsList,
  articleList,
  contentData,
  recommendTags,
}: {
  model?: HomeArticleModel;
  gptsList?: [HomeGPTsModel];
  articleList?: [HomeArticleModel];
  contentData?: any;
  recommendTags?: [HomeArticleModel];
}) => {
  const { t } = useTranslation();
  const router = useRouter();
  const { width } = useScreenSize();
  const currentHref = typeof window !== 'undefined' ? window.location.href : '';

  const itemList = () => {
    if (width >= 768) {
      const offsetTop = (gptsList?.length ?? 0) < 11 ? 64 : 28 - (gptsList?.length - 8) * 60;
      return (
        <Affix offsetTop={offsetTop}>
          <GPTsItemList dataList={gptsList} />
        </Affix>
      );
    }
    return <GPTsItemList dataList={gptsList} />;
  };

  return (
    <div className={styles.popularProductsContainer}>
      {width > 1170 && (
        <div style={{ float: 'left', marginLeft: `${(width - 1060) / 2 - 55}px` }}>
          <Affix offsetTop={74}>
            <SharePage shareUrl={currentHref} />
          </Affix>
        </div>
      )}

      <div className={styles.homeContent}>
        <Row gutter={20}>
          <Col md={18} xs={24}>
            <div className={styles.leftContainer}>
              {contentData == undefined || contentData?.title == undefined ? (
                <>
                  <Skeleton active />
                  <Skeleton.Image
                    active
                    style={{ marginTop: '20px', width: '100%', aspectRatio: '16/9' }}
                  />
                  <Skeleton active style={{ marginTop: '20px' }} />
                </>
              ) : (
                <>
                  <div className={styles.time}>{model?.create_time}</div>
                  {contentData?.book && <BookItem contentData={contentData} />}

                  <h1 className={styles.title}>{contentData?.title}</h1>
                  {/* <img className={styles.image} src={imgUrl(contentData?.image_url, "big")} loading="lazy" alt={contentData?.image_text} /> */}

                  {contentData?.image_url && <Image
                    className={styles.image}
                    src={imgUrl(contentData?.image_url, 'big')}
                    loading="lazy"
                    alt={contentData?.image_text}
                    layout="responsive"
                    width={500}
                    height={500}
                  />}

                  {contentData?.introduction && <p
                    className={styles.desc}
                    dangerouslySetInnerHTML={{ __html: contentData?.introduction }}
                  />}
                  {contentData?.body && <div
                    className={styles.content}
                    dangerouslySetInnerHTML={{ __html: contentData?.body }}
                  />}

                  {recommendTags?.length > 0 && (
                    <div className={styles.recommendTags}>
                      <h2>{t('Read More')}</h2>
                      {(recommendTags ?? []).map((item: HomeArticleModel, index: number) => {
                        return (
                          <div className={styles.linkContainer} key={item?.article_id}>
                            <span>{index + 1}.</span>
                            <Link
                              className={styles.link}
                              href={`/article/${item?.article_id}/${getPathTitle(item?.title)}`}
                            >
                              {item.title}
                            </Link>
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {model?.labels?.length > 0 && (
                    <div className={styles.tagContiner}>
                      <span className={styles.tagTitle}>{t('tags')}:</span>
                      {(model?.labels ?? []).map((item: any, index: number) => {
                        const itemStr = index == model?.labels.length - 1 ? item : `${item},`;
                        return (
                          <Link
                            href={`/search?tag=${item}`}
                            key={index}
                            className={styles.tagContent}
                          >
                            {itemStr}
                          </Link>
                        );
                      })}
                    </div>
                  )}

                  {width <= 1170 && <SharePage shareUrl={currentHref} />}
                </>
              )}
            </div>

            <div className={styles.otherContainer}>
              {articleList != undefined && articleList?.length > 1 && (
                <>
                  <h3>{t('peopleAlsoEnjoyed')}</h3>
                  {(articleList ?? []).map((item, index) => {
                    return (
                      <HomeFullItem
                        key={index}
                        showBottomLine={index != articleList.length - 1}
                        articleModel={item}
                        showPadding={false}
                      />
                    );
                  })}
                </>
              )}
            </div>
          </Col>
          <Col md={6} xs={24}>
            {itemList()}
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ArticleDetailUI;
